document.addEventListener('DOMContentLoaded', function () {
  // Get the toggle buttons and add event listeners
  const toggleButtons = document.querySelectorAll('.toggle-unit');
  const sizeDisplays = document.querySelectorAll('.size-display');

  // Ensure elements are present before proceeding
  if (toggleButtons.length === 0 || sizeDisplays.length === 0) {
    return; // Exit if no toggle buttons or size displays are found
  }

  // Get the country code from the hidden input
  const userCountryInput = document.getElementById('userCountry');
  const userCountry = userCountryInput ? userCountryInput.value : 'undefined';

  let preferredUnit;
  try {
    preferredUnit = localStorage.getItem('preferredUnit');
  } catch (e) {
    console.error('localStorage is not available:', e);
  }

  // If no stored preference, set based on country (Inches for US, CM for others)
  if (!preferredUnit) {
    preferredUnit = (userCountry === 'US') ? 'inches' : 'cm';
  }

  // Function to update size display based on the preferred unit
  function updateSizeDisplay(unit) {
    sizeDisplays.forEach(function(sizeDisplay) {
      let sizeText;
      if (unit === 'inches') {
        sizeText = sizeDisplay.dataset.sizeInches || 'N/A';
      } else {
        sizeText = sizeDisplay.dataset.sizeCm || 'N/A';
      }
      sizeDisplay.textContent = sizeText;
    });
  }

  // Function to add or remove the active (underline) class and update aria-pressed
  function updateActiveClass(unit) {
    toggleButtons.forEach(function(button) {
      const isActive = button.getAttribute('data-unit') === unit;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive);
    });
  }

  // Initial display update based on saved preference (or default geolocation-based unit)
  updateSizeDisplay(preferredUnit);
  updateActiveClass(preferredUnit);

  // Add event listeners to the toggle buttons
  toggleButtons.forEach(function(button) {
    button.addEventListener('click', function () {
      const selectedUnit = this.getAttribute('data-unit');
      try {
        localStorage.setItem('preferredUnit', selectedUnit); // Save the selected unit preference
      } catch (e) {
        console.error('Failed to save preferred unit to localStorage:', e);
      }
      updateSizeDisplay(selectedUnit); // Update the display based on the selected unit
      updateActiveClass(selectedUnit); // Update the underline for the selected unit
    });
  });
});
